module.exports = __webpack_public_path__ + "img/9788959525515.88a314db.jpg";